<template>
  <div>
    <span v-if="hidePersonalSections">
      <representative-form
        :form-model="formModel"
        :required="required"
      ></representative-form>
    </span>
    <naj-box :title="local.association.title">
      <v-row>
        <v-col
          cols="12"
          lg="3"
        >
          <naj-input
            :type-id="formFieldType.selectbox"
            :label="local.association.associationName"
            :value.sync="formModel.organizationId"
            :value-name.sync="formModel.organizationName"
            :items="associations"
            item-text="organizationName"
            item-value="id"
            item-description="unifiedNumber"
            validates="required|isIdAllowed"
            :disabled="isViewMode"
            @change="onOrganizationChange"
          ></naj-input>
        </v-col>
      </v-row>
    </naj-box>

    <naj-address
      :title="local.titleHeader.addressAssociation"
      :form-model="formModel.placeAddress"
      :required="required"
      :is-view-mode="isViewMode"
    ></naj-address>
    <span v-if="isRepresentative">
      <representatives-form
        :form-model="formModel"
        :required="required"
      ></representatives-form>
    </span>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import RepresentativesForm from './forms/representatives-form.vue';
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers(
  'LookupsModule'
);

export default {
  inject: ['$validator'],
  components: { RepresentativesForm },
  props: ['formModel', 'required', 'isViewMode', 'hidePersonalSections', 'isRepresentative'],
  computed: { ...mapLUTState(['associations']) },
  created() {
    this.getAssociations();
  },
  methods: {
    ...mapLUTActions(['getAssociations']),
    onOrganizationChange(organizationId) {
      const association = this.associations.find(e => e.id === organizationId);
      this.$set(this.formModel, 'name', association ? association.organizationName : undefined);
      this.$set(this.formModel, 'unifiedNumber', association ? association.unifiedNumber : undefined);
    },
  },
};
</script>
